import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useIntl } from 'react-intl';

import { SCIApi } from '../../../apis';
import { PaymentIssuerResponse } from '../payment.type';
import { paymentIssuers } from '../payment.api';
import { backendError } from '../payment.messages';

const getPaymentIssuers = async () => {
    const apiCalls = SCIApi.getInstance();
    const result: AxiosResponse<PaymentIssuerResponse[]> = await apiCalls.get<
        PaymentIssuerResponse[]
    >(paymentIssuers);

    return result?.data ?? result;
};

export const usePaymentIssuersKey = 'paymentIssuers';

export const usePaymentIssuers = (
    onSuccess?: (data: PaymentIssuerResponse[]) => void,
) => {
    const intl = useIntl();
    const genericErrorMessage = intl.formatMessage(backendError.generic);

    const [error, setError] = useState<React.ReactNode | string | undefined>(
        undefined,
    );

    const { isLoading, isError, data } = useQuery({
        queryKey: [usePaymentIssuersKey],
        queryFn: getPaymentIssuers,
        onSuccess: onSuccess,
        onError: () => setError(genericErrorMessage),
    });

    return {
        isLoading,
        isError,
        data,
        error,
    };
};
